import { registerPlugin } from '@capacitor/core'

export interface AppGroupUserDefaultsPlugin {
    set(options: {
        key: string
        value: string
        reloadAllTimelines?: boolean
    }): Promise<{}>
    get(options: { key: string }): Promise<{ value: string }>
}

const AppGroupUserDefaults = registerPlugin<AppGroupUserDefaultsPlugin>(
    'AppGroupUserDefaults'
)

export default AppGroupUserDefaults

export {}
